import React from 'react';
import { View } from 'react-native';
import { useT } from '@transifex/react';
import { cn as dsCn } from '@vidahealth/vida-ds';

import { useDsEnabled } from '../contexts/DesignSystem';
import { cn } from '../utils/cn';
import ThemedText from './ThemedText';

export const OrDivider: React.FC<{ className?: string }> = ({ className }) => {
  const dsEnabled = useDsEnabled();
  const t = useT();

  if (dsEnabled) {
    return (
      <View className={dsCn('flex-row items-center gap-ds-16', className)}>
        <View className='h-px flex-1 bg-separator' />
        <ThemedText type='bodySmall' color='subtle'>
          {t('or')}
        </ThemedText>
        <View className='h-px flex-1 bg-separator' />
      </View>
    );
  }

  return (
    <View className={cn('flex-row items-center', className)}>
      <View className='flex-1 border-t border-login-gray-10' />
      <ThemedText type='overline' color='subtle' className='mx-3' style={{ fontSize: 11 }}>
        {t('or')}
      </ThemedText>
      <View className='flex-1 border-t border-login-gray-10' />
    </View>
  );
};
